<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-cash-register"
      texto-titulo="Nuevo recibo"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <div class="card-primary mb-3 card">
          <div class="card-header">
            <i class="fas fa-user header-icon icon-gradient bg-alternate"></i>Datos de
            cliente
          </div>
          <div class="card-body p-0">
            <div class="grid-menu grid-menu-2col" v-if="!cliente.id">
              <div class="no-gutters row">
                <div class="col-12">
                  <button
                    class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary opacity-7"
                    @click="modalCliente = true"
                    tabindex="1"
                  >
                    <i class="fas fa-user-check btn-icon-wrapper btn-icon-lg mb-3"></i
                    >Seleccionar cliente
                  </button>
                </div>
              </div>
            </div>
            <div
              class="widget-content hoverable"
              v-else
              tabindex="1"
              @click="modalCliente = true"
            >
              <div class="widget-content-wrapper row">
                <div class="widget-content-left col-12">
                  <h5 class="widget-heading text-success">{{ cliente.nombre }}</h5>
                  <div class="widget-subheading opacity-10 row">
                    <span class="col-sm-auto col-12 text-alternate">
                      N° Doc/CUIL:
                      <b>{{ cliente.numero_documento | cuil }}</b>
                    </span>
                    <span class="col-sm-auto col-12">
                      Saldo actual:
                      <b class="text-danger"
                        >${{ cliente.saldo | numFormat("0,0.00") }}</b
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalSelectCliente
          v-if="modalCliente"
          @selectCliente="onSelectCliente"
          @cerrarModalCliente="modalCliente = false"
        ></ModalSelectCliente>
        <div class="row">
          <float-label label="Monto recibido:" clase="col-md-4 col-12" prepend="$">
            <input
              v-model="montoRecibido"
              id="montoRecibido"
              placeholder="0.00"
              type="text"
              inputmode="numeric"
              class="form-control"
              :class="
                enviado && (!$v.montoRecibido.required || !$v.montoRecibido.decimal)
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div class="invalid-feedback" v-if="enviado && !$v.montoRecibido.required">
                Debe ingresar el monto recibido
              </div>
              <div class="invalid-feedback" v-if="enviado && !$v.montoRecibido.decimal">
                Solo se aceptan números
              </div>
            </template>
          </float-label>
          <div class="offset-md-4 col-md-4 col-12">
            <button
              class="btn btn-info btn-wide btn-block"
              type="button"
              @click="guardarRecibo"
            >
              Guardar recibo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import ModalSelectCliente from "@/components/views/clientes/ModalSelectCliente";
import BlockUI from "@/components/loaders/BlockUI";
import { required, decimal } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Cliente from "@/models/cliente";
export default {
  name: "NuevoRecibo",
  components: {
    TituloComponent,
    ModalSelectCliente,
    BlockUI,
    FloatLabel,
  },
  data() {
    return {
      search: null,
      cliente: new Cliente(null, null, "", null, "", "", null, null, "", null),
      modalCliente: false,
      loading: false,
      montoRecibido: null,
      enviado: false,
    };
  },
  validations: {
    montoRecibido: { required, decimal },
  },
  methods: {
    guardarRecibo() {
      this.enviado = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      if (!this.cliente.id) {
        Swal.fire({
          icon: "error",
          title: "Oopss..",
          text: `Seleccione un cliente.`,
        });
        return false;
      }
      this.loading = true;
      let params = {
        user_id: this.$store.state.auth.user.id,
        cliente: this.cliente,
        monto: this.montoRecibido,
      };
      axios
        .post("/recibos", params)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `El recibo se guardó con éxito. El saldo actual es de $${this.$options.filters.numFormat(
                res.data.saldo,
                "0,0.00"
              )}`,
            });
            this.$router.push({ name: "ListarVentas" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
    onSelectCliente(cliente) {
      this.cliente = cliente;
    },
  },
};
</script>
